// extracted by mini-css-extract-plugin
var _1 = "TableModalCounter-modulecounter__zwzjD";
export { _1 as "counter" }
